import { render, staticRenderFns } from "./k2CouponLayout.vue?vue&type=template&id=18918408&"
import script from "./k2CouponLayout.vue?vue&type=script&lang=ts&"
export * from "./k2CouponLayout.vue?vue&type=script&lang=ts&"
import style0 from "./k2CouponLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports